module.exports = __webpack_public_path__ + "static/media/help.a7f3b816.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/help.svg
// module id = 553
// module chunks = 0